import { connect } from 'react-redux';
import RequestResetPassword from './RequestResetPassword';
import {
  getEmail,
  getEmailError,
  canInitiateResetPassword,
  isFetching,
  getError,
  shouldShowEmailError,
  isResetInitiated,
  getErrorCode,
} from '../../../state/reducers/ResetPasswordReducer';
import ResetPasswordActions from '../../../state/actions/ResetPasswordActions';

const mapStateToProps = (state) => ({
  email: getEmail(state),
  emailError: shouldShowEmailError(state) ? getEmailError(state) : '',
  canReset: canInitiateResetPassword(state),
  isFetching: isFetching(state),
  error: getError(state),
  errorCode: getErrorCode(state),
  resetInitiated: isResetInitiated(state),
});

const { initResetPasswordRequest, emailChanged, clearResetPassword } =
  ResetPasswordActions;

export default connect(mapStateToProps, {
  emailChanged,
  resetPassword: initResetPasswordRequest,
  resetState: clearResetPassword,
})(RequestResetPassword);



// WEBPACK FOOTER //
// ./src/view/forms/RequestResetPassword/index.js